<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body p-10">
        <div class="mb-24">
          <div class="flex md:flex-row gap-5 flex-col">
            <div class="w-full">
              <div class="border-1 w-full border border-solid rounded-lg p-5">
                <h5>{{ $t("Payer") }}</h5>
                <div class="mt-5">
                  <label class="vs-select--label">{{ $t("Pettycash") }}</label>
                  <v-select
                    label="name"
                    :class="isDisable ? 'disable-selectbox' : ''"
                    :options="listOfAccountPayer"
                    name="account"
                    v-model="model.pettyCashId"
                    @input="onlistOfAccountPayerSelected"
                    :clearable="false"
                    :disabled="isDisable"
                    dir="rtl"
                  >
                  </v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('account')"
                    >{{ errors.first("account") }}</span
                  >
                </div>
                <div class="mt-5">
                  <label class="vs-select--label">{{ $t("Account") }}</label>
                  <v-select
                    label="name"
                    :options="listOfFloatingAccountPayer"
                    name="floatingAccount"
                    v-model="model.pettyCashReferenceAccount"
                    :clearable="true"
                    :loading="searchFlag"
                    dir="rtl"
                  >
                  </v-select>
                </div>
              </div>
              <div class="">
                <vs-input
                  class="inputx mb-4 mt-5"
                  v-model="price"
                  name="bPrice"
                  :label="$t('Fee')"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('bPrice')"
                  >{{ errors.first("bPrice") }}</span
                >
              </div>

              <div class="mt-4">
                <label class="vs-select--label datepicker-lb">{{
                  $t("CreateOn")
                }}</label>
                <date-picker
                  v-model="model.createOn"
                  type="datetime"
                  format="jYYYY-jMM-jDD HH:mm:ss"
                  v-validate="'required'"
                  display-format="jYYYY-jMM-jDD HH:mm:ss"
                  id="date-picker"
                  :label="$t('CreateOn')"
                  name="date"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('CreateOn')"
                  >{{ errors.first("CreateOn") }}</span
                >
              </div>
            </div>
            <div class="border-1 w-full border border-solid rounded-lg p-5">
              <!-- <h5>{{ $t("Receiver") }}</h5> -->
              <div>
                <label class="vs-select--label">
                  {{ $t("Parties") }}
                </label>
                <treeselect
                  v-model="model.party"
                  name="productId"
                  :multiple="false"
                  :placeholder="$t('Search')"
                  :async="true"
                  :load-options="loadProducts"
                  v-validate="'required'"
                  :max-height="1000"
                  @select="onProductSelected"
                  @input="checkOnchangeValue"
                  ref="product"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('CostTitle')"
                  >{{ errors.first("CostTitle") }}</span
                >
              </div>
              <div class="mt-5">
                <label class="vs-select--label">{{ $t("CostTitle") }}</label>
                <v-select
                  label="name"
                  :options="listOfCostTitle"
                  name="costTitle"
                  v-model="model.costTitle"
                  :clearable="false"
                  :loading="searchFlagCostTitle"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('costTitle')"
                  >{{ errors.first("costTitle") }}</span
                >
              </div>
              <div class="mt-5">
                <label class="vs-select--label">{{ $t("CostCenter") }}</label>
                <v-select
                  label="name"
                  :options="listOfCostCenter"
                  name="costCenter"
                  v-model="model.costCenter"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('costCenter')"
                  >{{ errors.first("costCenter") }}</span
                >
              </div>
              <div class="mt-5">
                <vs-input
                  class="inputx mb-4 mt-5"
                  v-model="model.bankReferenceId"
                  name="bankReferenceId"
                  :label="$t('BankReferenceId')"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('bankReferenceId')"
                  >{{ errors.first("bankReferenceId") }}</span
                >
              </div>
              <!-- <div class="mt-5">
                <label class="vs-select--label">{{
                  $t("AccountFloating")
                }}</label>
                <v-select
                  label="name"
                  :options="listOfFloatingAccount"
                  name="floatingAccount"
                  v-model="model.receiverFloatingAccount"
                  :clearable="false"
                  dir="rtl"
                >
                </v-select>
              </div> -->
            </div>
          </div>
          <div>
            <vs-textarea
              rows="3"
              class="mt-4"
              name="Description"
              :label="$t('Description')"
              v-validate="'required'"
              v-model="model.description"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Description')"
              >{{ errors.first("Description") }}</span
            >
          </div>
          <vs-button
            type="filled"
            class="float-right mt-4"
            :class="model.id != null ? 'mt-12' : ''"
            @click.prevent="submitForm"
            :disabled="
              !model.description ||
              !model.createOn ||
              !price ||
              !model.pettyCashId ||
              !model.costTitle ||
              !model.party ||
              !model.pettyCashReferenceAccount
            "
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

const dict = {
  custom: {
    CreateOn: {
      required: "لطفا تاریخ درج را وارد نمایید.",
    },
    account: {
      required: "لطفا  حساب را وارد نمایید.",
    },
    bPrice: {
      required: "لطفا  مبلغ را وارد نمایید.",
    },
    Description: {
      required: "لطفا  توضیحات را وارد نمایید.",
    },
    costTitle: {
      required: "لطفا  عنوان هزینه را وارد نمایید.",
    },
    bankReferenceId: {
      required: "لطفا  شماره رهگیری را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    Treeselect,
    "v-select": vSelect,
  },
  data() {
    return {
      listOfAccount: [],
      listOfAccountPayer: [],
      listOfFloatingAccount: [],
      listOfFloatingAccountPayer: [],
      listOfCostCenterPayer: [],
      listOfCostTitle: [],
      listOfCostCenter: [],
      price: null,
      model: {},
      disabled: false,
      fundReplenishment: -1,
      searchQueryNew: "",
      searchQueryOld: "",
      isDisable: false,
      searchFlagCostTitle: false,
      searchFlag: false,
    };
  },

  mounted() {
    this.getData();
    this.fundReplenishment = this.$route.params.id;
  },

  methods: {
    ...mapActions({
      fetchAccounts: "pettyCash/getAllLastLevelOfAccounts",
      fetchFloatingAccounts: "pettyCash/getAllLastLevelOfFloatingAccounts",
      createAccount: "pettyCash/savePayment",
      fetchPettyCash: "pettyCash/fetchPettyCash",
      fetchPettyCashAccountInfo: "pettyCash/fetchPettyCashAccountInfoById",
      fetchCostTitle: "costCenter/fetchAllCostTitleByParent",
      fetchCostCenter: "pettyCash/fetchCostCenter",
      searchParty: "costCenter/searchParty",
    }),
    loadProducts({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchParty(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                  name: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onProductSelected(data) {
      this.searchFlagCostTitle = true;
      this.fetchCostTitle(data.id).then((result) => {
        this.listOfCostTitle = result;
        this.searchFlagCostTitle = false;
      });
      this.model.partyInfo = {
        name: data.name,
        id: data.id,
      };
    },
    checkOnchangeValue() {
      if (!this.model.party) {
        this.listOfCostTitle = [];
        this.model.partyInfo = {};
        this.model.costTitle = {};
      }
    },
    getData() {
      this.fetchCostCenter().then((result) => {
        this.listOfCostCenter = result;
      });
      this.fetchPettyCash().then((result) => {
        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.name + " " + element.family,
            accountInfo: element.accountInfo,
          };
          this.listOfAccountPayer.push(x);
        });
        if (this.listOfAccountPayer.length === 1) {
          this.model.pettyCashId = this.listOfAccountPayer[0];
          this.isDisable = true;
          this.listOfFloatingAccountPayer = this.model.pettyCashId.accountInfo;
        } else {
          this.isDisable = false;
        }
        // this.listOfAccount = result;
        // this.listOfAccountPayer = result;
      });
    },

    onlistOfAccountPayerSelected() {
      this.searchFlag = true;
      if (this.model.pettyCashReferenceAccount) {
        this.model.pettyCashReferenceAccount = null;
      }
      this.fetchPettyCashAccountInfo(this.model.pettyCashId.id).then(
        (result) => {
          this.listOfFloatingAccountPayer = result;
          this.searchFlag = false;
        }
      );

    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          var payload = {
            amount: this.model.amount,
            bankReferenceId: this.model.bankReferenceId,
            createOn: this.model.createOn,
            fundReplenishmentReferenceId: this.fundReplenishment,
            description: this.model.description,
            partyCostTitleInfo: this.model.costTitle,
            costCenterId: this.model.costCenter
              ? this.model.costCenter.id
              : null,
            partyId: this.model.partyInfo.id,
            pettyCashId: this.model.pettyCashId.id,
            pettyCashReferenceAccountCode:
              this.model.pettyCashReferenceAccount.code,
          };
          this.createAccount(payload).then(() => {
            this.$router.go(-1);
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    price(value) {
      if (value) {
        var n = parseFloat(value.replace(/,/g, ""), 10);
        this.price = n.toLocaleString();
        this.model.amount = this.price.replace(/,/g, "");
      } else {
        this.price = null;
        this.model.amount = null;
      }
    },
  },
};
</script>
